import React, { Component } from 'react';
import * as $ from 'jquery';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import { Link } from 'react-router-dom';
import * as MySound from '../../MySound';
import { confirm } from 'react-bootstrap-confirmation';
import { alert } from 'react-bootstrap-confirmation';
import ViewAttributes from '../ViewAttributes';


export class AddNew_ProductCount extends Component {
    static displayName = AddNew_ProductCount.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            alertMessage: "",
            selectedStocktake:"",
            selectedProductId: props.location.state.selectedProductId,
            selectedProductCode: "",
            selectedLocationId: props.location.state.selectedLocationId,
            selectedLocationBarcode: props.location.state.selectedLocationBarcode,
            previouspage: props.location.state.previouspage,
            enteredQty: 0,
            productHasAttributes: false,
            countTimeInSeconds: 0,
            locationBarcode: "",
            travelTimeInSeconds: 0,
            status: "",
            extraProductDetails: "",
            expiryAndPackingDateCheckedByUser: false,
            isBlind: false,
            wh_statuses:[]

        };
        this.history = props.history;
    }

    componentDidMount() {

        if (MyGlobal.isStockCounted === "true") {
            this.navigateToPreviousPage();
            return;
        }

        if (!MyGlobal.selected_stocktake) {
            this.clearAll("Please select a Stocktake");
            return;
        }

        var selectedStocktakeParsedData = JSON.parse(MyGlobal.selected_stocktake);
        if (selectedStocktakeParsedData) {
            this.state.selectedStocktake = selectedStocktakeParsedData;
        }

        if (!this.state.selectedStocktake.stocktakeId || this.state.selectedStocktake.stocktakeId === "") {
            this.clearAll("Please select a Stocktake");
            return;
        }


        this.getExtraProductDetails();
        this.loadWHInventoryStatuses();
  

    }
    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

    async loadWHInventoryStatuses() {
        fetch(`api/Stocktake/GetWHInventoryStatuses`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ wh_statuses: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success)
                        {
                            if (data && data.length > 0)
                            {
                                this.setState({ wh_statuses: data, alertMessage: ""});
                                return;
                            }
                            else
                            {
                                this.setState({ wh_statuses: [], alertMessage: "Failed to load Statuses" });
                            }
                        }
                        else {
                            this.setState({ wh_statuses: [], alertMessage: apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ wh_statuses: [], alertMessage: "Failed to load Statuses" });
                    }
                }

            })
            .catch(error => {
                this.setState({ wh_statuses: [], alertMessage: error });
            });
    }


    async getExtraProductDetails() {
        this.state.loading = true;

        fetch(`api/Stocktake/GetExtraProductDetails?stocktakeId=${this.state.selectedStocktake.stocktakeId}&productId=${this.state.selectedProductId}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ extraProductDetails: "", alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            if (data && data.length > 0) {
                                this.setState({ extraProductDetails: data[0], alertMessage: "", selectedProductCode: data[0].productCode, isBlind :data[0].isBlind });
                                return;
                            }
                            else {
                                this.setState({ extraProductDetails: "", alertMessage: "No data found"  });
                            }
                        }
                        else {
                            this.setState({ extraProductDetails: "", alertMessage: apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ extraProductDetails: "", alertMessage: "No data found" });
                    }
                }

            })
            .catch(error => {
                this.setState({ extraProductDetails: "", alertMessage: error });
            });
    }

    addExtraLine() {
        this.setState({ alertMessage: "" });

        if ($.isNumeric(this.state.enteredQty) === false) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Invalid quantity" });
            return;
        }

        if (!this.state.extraProductDetails) {
            this.setState({ alertMessage: "Product details are not mapped" });
            return;
        }
        var attributeValidationMsg = "";
        var isValid = true;

        if (this.state.extraProductDetails.productAttribute !== 0) {


            if (this.state.extraProductDetails.isRequiredExpiry === true && (!this.state.extraProductDetails.dataExpiry || this.state.extraProductDetails.dataExpiry === "")) {
                isValid = false;
                attributeValidationMsg += "Expiry is required  \n";
            }
            if (this.state.extraProductDetails.isRequiredPackingDate === true && (!this.state.extraProductDetails.dataPacking || this.state.extraProductDetails.dataPacking === "")) {
                isValid = false;
                attributeValidationMsg += "Packing date is required \n";
            }
            if (this.state.extraProductDetails.isRequiredGrade1 === true && (!this.state.extraProductDetails.dataGrade1 || this.state.extraProductDetails.dataGrade1 === "")) {
                isValid = false;
                attributeValidationMsg += this.state.extraProductDetails.altNameGrade1 + " is required  \n";
            }
            if (this.state.extraProductDetails.isRequiredGrade2 === true && (!this.state.extraProductDetails.dataGrade2 || this.state.extraProductDetails.dataGrade2 === "")) {
                isValid = false;
                attributeValidationMsg += this.state.extraProductDetails.altNameGrade2 + " is required  \n";
            }
            if (this.state.extraProductDetails.isRequiredGrade3 === true && (!this.state.extraProductDetails.dataGrade3 || this.state.extraProductDetails.dataGrade3 === "")) {
                isValid = false;
                attributeValidationMsg += this.state.extraProductDetails.altNameGrade3 + " is required  \n";
            }

            if (!isValid) {
                this.setState({ alertMessage: attributeValidationMsg });
                return;
            }

            if (!this.state.expiryAndPackingDateCheckedByUser && (this.state.extraProductDetails.isRequiredExpiry || this.state.extraProductDetails.isRequiredPackingDate)) {

                const displayDateConfirmation = async () => {
                    const confirmationResult = await confirm("Please confirm you have selected the correct dates");
                    if (confirmationResult === true) {
                        this.state.expiryAndPackingDateCheckedByUser = true;
                        this.checkForExistingProducts();
                        return;
                    }
                    else {
                        return;
                    }
                }
                displayDateConfirmation();
            }
            else {
                this.checkForExistingProducts();
                return;
            }
        }
        else {
            this.checkForExistingProducts();
            return;
        }
        

    }

    validateEntereQty() {



        if (this.state.enteredQty && this.state.enteredQty.length > 4) {
            const displayValidateQtyConfirmation = async () => {
                const confirmationResult = await confirm("Please confirm quantity entered is correct");
                if (confirmationResult === true) {
                    this.submitExtraLineToWS();
                }
                else {
                    this.setState({ enteredQty: 0 });
                    return;
                }
            }
            displayValidateQtyConfirmation();
        }
        else {
            this.submitExtraLineToWS();
        }
    }

    async checkForExistingProducts() {
        this.state.loading = true;


        this.state.selectedLocationBarcode = this.state.selectedLocationBarcode.trim();
        var barCodeFormat = this.state.selectedLocationBarcode.split("-");
        if (!barCodeFormat || barCodeFormat.length !== 4) {

            this.clearAll("Invalid Location!! Location Barcode should be of this format : Stage-01-01-09");
            MySound.play(MySound.Sound.stop);
            return;
        }

        this.state.extraProductDetails.locationRow = barCodeFormat[0];
        this.state.extraProductDetails.locationColumn = barCodeFormat[1];
        this.state.extraProductDetails.locationLevel = barCodeFormat[2];
        this.state.extraProductDetails.locationTray = barCodeFormat[3];
        this.state.extraProductDetails.latestCount = this.state.enteredQty;
        this.state.extraProductDetails.status = this.state.status;
        this.state.extraProductDetails.stocktakeId = this.state.selectedStocktake.stocktakeId;
        this.state.extraProductDetails.spec_No = "";
        this.state.extraProductDetails.case_No = "";
        this.state.extraProductDetails.colosysQty = 0
        this.state.extraProductDetails.isExtra = true;
        this.state.extraProductDetails.locationID = this.state.selectedLocationId;
        this.state.extraProductDetails.productID = this.state.selectedProductId;


        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify( this.state.extraProductDetails)
        };
        fetch('api/Stocktake/CheckForExistingProducts', requestOptions)
            .then(async response => {
                this.state.loading = false;

                // check for error response
                if (!response.ok) {
                    MySound.play(MySound.Sound.stop);
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Failed to check if Product already exists!! " + errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        var existingProducts = data;
                        if (apiResponse.success) {
                            if (existingProducts && existingProducts.length > 0) {
                                this.setState({
                                    alertMessage:"This product already exists with these attributes in this location. If you wish to recount this location please use 'Adhoc Count'" });
                                return;
                            }
                            else {
                                this.submitExtraLineToWS();
                            }
                        }
                        else {
                            MySound.play(MySound.Sound.stop);
                            this.setState({ alertMessage: "Failed to check if Product already exists!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        MySound.play(MySound.Sound.stop);
                        this.setState({ alertMessage: "Failed to check if Product already exists!!" });
                    }

                }
            })
            .catch(error => {
                MySound.play(MySound.Sound.stop);
                this.state.loading = false;
                this.setState({ alertMessage: error });
            });

    }


    async submitExtraLineToWS() {
        this.state.loading = true;

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(
                {
                    UserId: MyGlobal.user,
                    ExtraProductDetails: this.state.extraProductDetails
                })
        };
        fetch('api/Stocktake/SubmitExtraLine', requestOptions)
            .then(async response => {
                this.state.loading = false;

                // check for error response
                if (!response.ok) {
                    MySound.play(MySound.Sound.stop);
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Failed to update Quantity!! " + errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            if (data && data.length > 0) {
                                MyGlobal.isStockCounted = "true";

                                MySound.play(MySound.Sound.next);

                                this.navigateToPreviousPage();

                            }
                            else {
                                MySound.play(MySound.Sound.stop);
                                this.setState({ alertMessage: "Failed to update Quantity!!  " + data.responseDescription });
                            }
                        }
                        else {
                            MySound.play(MySound.Sound.stop);
                            this.setState({ alertMessage: "Failed to update Quantity!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        MySound.play(MySound.Sound.stop);
                        this.setState({ alertMessage: "Failed to update Quantity!!" });
                    }

                }
            })
            .catch(error => {
                MySound.play(MySound.Sound.stop);
                this.state.loading = false;
                this.setState({ alertMessage: error });
            });

    }



    navigateToPreviousPage() {
        switch (this.state.previouspage) {
            case "Recount_ConfirmLocation":
                this.goto("../Recount/Recount_ConfirmLocation");
                break;
            case "FirstCount_ConfirmLocation":
                this.goto("../FirstCount/FirstCount_ConfirmLocation");
                break;
            default:
                this.goto("../StocktakeTasks");
        }
    }

    render() {

        let loadingHtml = this.state.loading
            ? <p><em>Loading extra product details...</em></p>
            : "";

        const handleQtyInputKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.addExtraLine();
            }
        };

        const handleNextBtnClick = e => {

            this.addExtraLine();

        };

        const alertStyle = {
            whiteSpace: "pre"
        };
   
        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <div style={alertStyle} className="alert alert-danger" role="alert">{alertMessage}</div>: "";


        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h5>Add Extra - Confirm Quantity</h5></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('AddNew_ProductSearch'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}> {loadingHtml}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <label> Quantity :</label>
                            <input ref="qtyInput" className="form-control" type="number" value={this.state.enteredQty}
                                onChange={(e) => {
                                    this.setState({ enteredQty: e.target.value });
                                }} onKeyPress={handleQtyInputKeyPress} readOnly={this.state.loading} >
                            </input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={handleNextBtnClick}>Next</button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Location :</label>
                        </Col>
                        <Col xs={9}>
                            <label> {this.state.selectedLocationBarcode.trim()} </label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Product :</label>
                        </Col>
                        <Col xs={9}>
                            <label>{this.state.extraProductDetails && this.state.extraProductDetails.productCode !== "" ? this.state.extraProductDetails.productCode : ""} </label>
                        </Col>
                    </Row>
                   
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Status :</label>
                        </Col>
                        <Col xs={9}>
                            <select className="form-select form-control" aria-label=".form-select-lg example"
                                value={this.state.status}
                                onChange={(e) => {
                                    this.setState({ status: e.target.value });
                                }}>
                                {this.state.wh_statuses.map((status) => (
                                    <option key={status.id} value={status.code} >
                                        {status.description}
                                    </option>
                                ))}
                            </select>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={3}>
                            <label style={{ color: this.state.extraProductDetails.productAttribute !== 0 && this.state.extraProductDetails.isRequiredExpiry ? 'red' : 'grey' }} > Expiry :</label>
                        </Col>
                        <Col xs={9}>
                            <input className="form-control" type="date" defaultValue={this.state.extraProductDetails && this.state.extraProductDetails.dataExpiry  ? this.state.extraProductDetails.dataExpiry: ""}
                                onChange={(e) => {
                                    this.state.extraProductDetails.dataExpiry = e.target.value;
                                }} readOnly={this.state.extraProductDetails.productAttribute === 0 || !this.state.extraProductDetails.isRequiredExpiry} >
                            </input>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={3}>
                            <label style={{ color: this.state.extraProductDetails.productAttribute !== 0 && this.state.extraProductDetails.isRequiredPackingDate ? 'red' : 'grey' }} > Packing :</label>
                        </Col>
                        <Col xs={9}>
                            <input className="form-control" type="date" defaultValue={this.state.extraProductDetails && this.state.extraProductDetails.dataPacking  ? this.state.extraProductDetails.dataPacking : ""}
                                onChange={(e) => {
                                    this.state.extraProductDetails.dataPacking = e.target.value;
                                }} readOnly={this.state.extraProductDetails.productAttribute === 0 || !this.state.extraProductDetails.isRequiredPackingDate} >
                            </input>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={3}>
                            <label style={{ color: this.state.extraProductDetails.productAttribute !== 0 && this.state.extraProductDetails.isRequiredGrade1 ? 'red' : 'grey' }} >
                                {this.state.extraProductDetails.isRequiredGrade1 ?  this.state.extraProductDetails.altNameGrade1 : "Grade1" }
                            </label>
                        </Col>
                        <Col xs={9}>
                            <input className="form-control" type="text" defaultValue={this.state.extraProductDetails && this.state.extraProductDetails.dataGrade1 ? this.state.extraProductDetails.dataGrade1 : ""}
                                onChange={(e) => {
                                    this.state.extraProductDetails.dataGrade1 = e.target.value;
                                }} readOnly={this.state.extraProductDetails.productAttribute === 0 || !this.state.extraProductDetails.isRequiredGrade1} >
                            </input>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={3}>
                            <label style={{ color: this.state.extraProductDetails.productAttribute !== 0 && this.state.extraProductDetails.isRequiredGrade2 ? 'red' : 'grey' }} >
                                {this.state.extraProductDetails.isRequiredGrade2 ? this.state.extraProductDetails.altNameGrade2 : "Grade2"}
                            </label>
                        </Col>
                        <Col xs={9}>
                            <input className="form-control" type="text" defaultValue={this.state.extraProductDetails && this.state.extraProductDetails.dataGrade2 ? this.state.extraProductDetails.dataGrade2 : ""}
                                onChange={(e) => {
                                    this.state.extraProductDetails.dataGrade2 = e.target.value;
                                }} readOnly={this.state.extraProductDetails.productAttribute === 0 || !this.state.extraProductDetails.isRequiredGrade2} >
                            </input>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={3}>
                            <label style={{ color: this.state.extraProductDetails.productAttribute !== 0 && this.state.extraProductDetails.isRequiredGrade3 ? 'red' : 'grey' }} >
                                {this.state.extraProductDetails.isRequiredGrade3 ? this.state.extraProductDetails.altNameGrade3 : "Grade3"}
                            </label>
                        </Col>
                        <Col xs={9}>
                            <input className="form-control" type="text" defaultValue={this.state.extraProductDetails && this.state.extraProductDetails.dataGrade3 ? this.state.extraProductDetails.dataGrade3 : ""}
                                onChange={(e) => {
                                    this.state.extraProductDetails.dataGrade3 = e.target.value;
                                }} readOnly={this.state.extraProductDetails.productAttribute === 0 || !this.state.extraProductDetails.isRequiredGrade3} >
                            </input>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Link className="btn btn-success col-12 mb-2" to={{ pathname: "AddNew_ProductDetails", state: this.state }}>Details</Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Link className="btn btn-success col-12 mb-2" to={{ pathname: "AddNew_DisplayColosysProductLocation", state: this.state }}>Locations</Link>
                        </Col>
                    </Row>
                </Container>
                
            </div>)

    }


}
